import { Button, Flex, Layout, theme as antdTheme } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { NavProfile } from './NavProfile';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';

const { Header } = Layout;

export const HeaderNav = () => {
  const {
    token: { colorBgContainer, colorBgLayout },
  } = antdTheme.useToken();
  const { isMobile, setOpenMobileNav } = useTheme();
  return (
    <Header
      style={{ padding: 0, background: colorBgContainer, borderLeft: `1px solid ${colorBgLayout}` }}
    >
      <Flex
        justify={isMobile ? 'space-between' : 'end'}
        align="center"
        style={{ height: '100%', paddingRight: 16, paddingLeft: 16 }}
        gap={16}
      >
        {isMobile && (
          <Button onClick={() => setOpenMobileNav(true)}>
            <MenuOutlined />
          </Button>
        )}
        <NavProfile />
      </Flex>
    </Header>
  );
};

export default HeaderNav;
